import React from 'react';
import { Award, CheckCircle, Shield, FileText } from 'lucide-react';

const Certifications = () => {
  const certifications = [
    {
      icon: Award,
      title: 'ISO 9001:2015',
      description: 'Quality Management System',
      details: 'Internationally recognized quality management standards ensuring consistent product excellence.',
      badge: 'https://images.pexels.com/photos/8849270/pexels-photo-8849270.jpeg'
    },
    {
      icon: Shield,
      title: 'FSSAI License',
      description: 'Food Safety Standards Authority',
      details: 'Certified for food safety and hygiene standards in animal feed manufacturing.',
      badge: 'https://images.pexels.com/photos/8849270/pexels-photo-8849270.jpeg'
    },
    {
      icon: CheckCircle,
      title: 'BIS Certification',
      description: 'Bureau of Indian Standards',
      details: 'Compliance with Indian national standards for quality and safety specifications.',
      badge: 'https://images.pexels.com/photos/8849270/pexels-photo-8849270.jpeg'
    },
    {
      icon: FileText,
      title: 'Organic Certified',
      description: 'Organic Feed Production',
      details: 'Certified organic manufacturing processes for premium natural feed products.',
      badge: 'https://images.pexels.com/photos/8849270/pexels-photo-8849270.jpeg'
    }
  ];

  const qualityPoints = [
    'State-of-the-art testing laboratory',
    'Regular third-party quality audits',
    'Batch-wise quality documentation',
    'Temperature controlled storage',
    'Contamination-free processing',
    'Nutritional analysis certification'
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-amber-800 mb-6">
            Certifications & Quality Assurance
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Our commitment to excellence is validated by prestigious certifications 
            and rigorous quality control processes.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {certifications.map((cert, index) => (
            <div key={index} className="group text-center">
              <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-200 hover:scale-105">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-amber-500 to-yellow-500 rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-200">
                  <cert.icon className="text-white" size={32} />
                </div>
                
                <h3 className="text-xl font-bold text-amber-800 mb-2">{cert.title}</h3>
                <p className="text-amber-600 font-semibold mb-4">{cert.description}</p>
                <p className="text-gray-600 text-sm leading-relaxed">{cert.details}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Quality Assurance Process */}
        <div className="bg-gradient-to-br from-gray-50 to-amber-50 rounded-2xl p-8 lg:p-12">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-amber-800 mb-6">
                Our Quality Assurance Process
              </h3>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                We follow a comprehensive quality control system from raw material 
                procurement to final product delivery, ensuring every batch meets 
                our stringent quality standards.
              </p>
              
              <div className="space-y-4">
                {qualityPoints.map((point, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <div className="w-6 h-6 bg-gradient-to-r from-green-400 to-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <CheckCircle className="text-white" size={16} />
                    </div>
                    <span className="text-gray-700 font-medium">{point}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="relative">
              <img 
                src="https://techsafety.com/sites/default/files/styles/blog_/public/2021-10/shutterstock_1682324479_0.jpg" 
                alt="Quality testing laboratory"
                className="rounded-2xl shadow-2xl w-full h-[400px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>

        {/* Download Section */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-amber-600 to-yellow-600 rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">Download Certificates</h3>
            <p className="text-lg mb-6 opacity-90">
              Get detailed information about our certifications and quality standards.
            </p>
            <button className="bg-white text-amber-600 px-8 py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors duration-200">
              Download Certificate Pack
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Certifications;